import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PoweroffOutlinedSvg from "@ant-design/icons-svg/es/asn/PoweroffOutlined";
import AntdIcon from "../components/AntdIcon";
var PoweroffOutlined = function PoweroffOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PoweroffOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PoweroffOutlined.displayName = 'PoweroffOutlined';
}
export default /*#__PURE__*/React.forwardRef(PoweroffOutlined);